import {
  getContentTextFields,
  omitMappedContentText,
} from '@eliadmin/core/src/api/content-fields/content-text-mapping';
import type { ContentFieldsOwner } from '@eliadmin/core/src/api/content-fields/content-fields-types';

export function getEventContentTexts(owner: ContentFieldsOwner | null | undefined) {
  return getContentTextFields(
    owner,
    [3, 4, 5, 6].map(groupId => ({ groupId, component: 'same-name-text' as const, itemIndex: 0 })),
  );
}

export function getCourseContentTexts(owner: ContentFieldsOwner | null | undefined) {
  return getContentTextFields(
    owner,
    [2, 7].map(groupId => ({ groupId, component: 'same-name-text' as const, itemIndex: 0 })),
  );
}

export function getEventRemainingContent(owner: ContentFieldsOwner) {
  return omitMappedContentText(
    owner,
    [3, 4, 5, 6].map(groupId => ({ groupId, component: 'same-name-text' as const, itemIndex: 0 })),
  );
}
